import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ResetPasswordService } from '../reset-password.service';

@Component({
  selector: 'app-reset-password-session',
  templateUrl: './reset-password-session.component.html',
  styleUrls: ['./reset-password-session.component.css'],
})
export class ResetPasswordSessionComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private serviceAuth: ResetPasswordService,
    private router: Router,
  ) {
    this.loginForm = this.fb.group({
      emailId: ['', [Validators.required, Validators.pattern(/\S+@\S+\.\S+/)]],
    });
  }

  image_key = environment.client_env;
  //@ts-ignore
  imageUrl = environment[this.image_key]['sidebar_image'];
  loginForm: FormGroup;
  emailId: String = '';
  errorMessageUserName = '';
  errorMessagePassword = '';
  errorMsg = 'Error';
  submited = false;
  failedAuth = false;
  ngOnInit() {}

  get f() {
    return this.loginForm.controls;
  }
  onSubmit(form: FormGroup) {
    this.submited = true;

    this.serviceAuth
      .resetPasswordSession(form.value['emailId'])
      .then((result) => {
        if (result['success'] === '1') {
          localStorage.setItem(
            'resetPasswordData',
            JSON.stringify(result['data']),
          );
          // this.router.navigateByUrl('');

          this.router.navigateByUrl('/verify-otp');
        } else {
          this.errorMsg = result['message'];
          this.failedAuth = true;
        }
      })
      .catch((error) => {});
  }
  resetForm() {
    this.submited = false;
    this.failedAuth = false;
  }
}
